import React from "react";
import { Box, MenuItem } from "@mui/material";
import { LEAD_STATUS_DEFINITIONS } from "../constants/leadStatuses";
import LeadStatusIcon from "./LeadStatusIcon";

export function LeadStatusFilterMenuItems({ includeAll = true }) {
  return (
    <>
      {includeAll && <MenuItem value="all">All Statuses</MenuItem>}
      {LEAD_STATUS_DEFINITIONS.map(({ value }) => (
        <MenuItem key={value} value={value}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box sx={{ mr: 1, display: "flex", alignItems: "center" }}>
              <LeadStatusIcon status={value} size={20} />
            </Box>
            <span>{value}</span>
          </Box>
        </MenuItem>
      ))}
    </>
  );
}

export function LeadStatusSelectMenuItems() {
  return LEAD_STATUS_DEFINITIONS.map(({ value }) => (
    <MenuItem key={value} value={value}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ mr: 1, display: "flex", alignItems: "center" }}>
          <LeadStatusIcon status={value} size={20} />
        </Box>
        <span>{value}</span>
      </Box>
    </MenuItem>
  ));
}
